import { useEffect } from "react";
import { toast } from "react-toastify";
import Loader from "@/components/Icons/Loader";
import FileInfo from "@/components/Icons/FileInfo";
import Checkbox from "@/components/Icons/Checkbox";
import Warning from "@/components/Icons/Warning";

// -----------------------------------------------------------------------------

export default function PreviewToasts() {
	const shareUrl = "https://www.google.com";

	useEffect(() => {
		// Create link - all browser except safari
		toast.success(
			<div>
				<a
					href={shareUrl}
					target="_blank"
					rel="noopener noreferrer"
					className="toast-link toast-link-success"
				>
					Link
				</a>{" "}
				copied to clipboard.
			</div>,
			{
				icon: <Checkbox />,
				autoClose: false,
			},
		);

		// Create link - safari old
		toast.info(
			<div>
				<a
					href={shareUrl}
					target="_blank"
					rel="noopener noreferrer"
					className="toast-link toast-link-info"
				>
					Link
				</a>{" "}
				is ready.
			</div>,
			{
				autoClose: false,
				icon: <FileInfo />,
			},
		);

		// Create link - safari new
		toast.success(
			<div>
				<a
					href={shareUrl}
					target="_blank"
					rel="noopener noreferrer"
					className="toast-link toast-link-success"
				>
					Link
				</a>{" "}
				is ready.
			</div>,
			{
				autoClose: false,
				icon: <Checkbox />,
			},
		);

		// Export png - success
		toast.promise(
			new Promise((resolve, reject) => {
				setTimeout(() => {
					resolve("Exported!");
				}, 9999);
			}),
			{
				pending: {
					render: () => "Exporting go brr...",
					icon: <Loader className="toast-icon-loading" />,
				},
				success: {
					render: () => "Exported!",
					icon: <Checkbox />,
					autoClose: 9999,
				},
				error: {
					render: () => "Export failed. Please try again.",
					icon: <Warning />,
				},
			},
		);

		// Export png - error
		toast.promise(
			new Promise((resolve, reject) => {
				setTimeout(() => {
					reject("Export failed. Please try again.");
				}, 9999);
			}),
			{
				pending: {
					render: () => "Exporting go brr...",
					icon: <Loader className="toast-icon-loading" />,
				},
				success: {
					render: () => "Exported!",
					icon: <Checkbox />,
				},
				error: {
					render: () => "Export failed. Please try again.",
					icon: <Warning />,
					autoClose: 9999,
				},
			},
		);
	}, []);

	// -----------------------------------------------------------------------------

	return (
		<>
			<p>Hello from PreviewToasts</p>
		</>
	);
}
